// This file configures the initialization of Sentry on the client.
// The added config here will be used whenever a users loads a page in their browser.
// https://docs.sentry.io/platforms/javascript/guides/nextjs/

;globalThis["_sentryRouteManifest"] = "{\"dynamicRoutes\":[{\"path\":\"/blog/:slug\",\"regex\":\"^/blog/([^/]+)$\",\"paramNames\":[\"slug\"],\"hasOptionalPrefix\":false}],\"staticRoutes\":[{\"path\":\"/\"},{\"path\":\"/about-faqs\"},{\"path\":\"/about-us\"},{\"path\":\"/blog\"},{\"path\":\"/cookies-policy\"},{\"path\":\"/faqs\"},{\"path\":\"/licenses\"},{\"path\":\"/manage-account-faqs\"},{\"path\":\"/newsletter\"},{\"path\":\"/privacy-policy\"},{\"path\":\"/referral-faqs\"},{\"path\":\"/sendmoney-faqs\"},{\"path\":\"/state-complaint-disclosures\"},{\"path\":\"/terms-and-conditions\"}],\"isrRoutes\":[\"/blog/:slug\"]}";globalThis["_sentryNextJsVersion"] = "16.2.6";import * as Sentry from "@sentry/nextjs";
import { SENTRY_DSN } from "./constants/envs";

Sentry.init({
  dsn: SENTRY_DSN,

  // Define how likely traces are sampled. Adjust this value in production, or use tracesSampler for greater control.
  tracesSampleRate: 1,
  // Enable logs to be sent to Sentry
  enableLogs: true,

  // Enable sending user PII (Personally Identifiable Information)
  // https://docs.sentry.io/platforms/javascript/guides/nextjs/configuration/options/#sendDefaultPii
  sendDefaultPii: true,
});

export const onRouterTransitionStart = Sentry.captureRouterTransitionStart;
